'use client';

import type { ReactNode, MouseEventHandler } from 'react';

import { Anchor } from '@packages/shared/src/ui/Anchor/Anchor';
import type { Language } from '@packages/config/src/default/types';
import { Link } from '../../../../Link/Link';

export type SlotEquivalentLinksItemProps = {
  ariaLabel?: string;
  children: ReactNode;
  href: string;
  language?: Language;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  isBusy?: boolean;
  /** Use router link or default <a> tags
   * @default true
   */
  useRouterLink?: boolean;
};
export const SlotEquivalentLinksItem = ({
  ariaLabel,
  href,
  language,
  children,
  onClick,
  isBusy = false,
  useRouterLink = true,
}: SlotEquivalentLinksItemProps) => {
  const busyClass = isBusy ? 'pointer-events-none touch-none opacity-50' : '';
  const sharedProps = {
    href,
    onClick: isBusy ? undefined : onClick,
    'aria-label': ariaLabel,
    'aria-busy': isBusy || undefined,
    'aria-disabled': isBusy || undefined,
  };

  return (
    <li className="border-color-grey border-b">
      {useRouterLink ? (
        <Link
          className={`flex items-center ${busyClass} gap-3 px-2 py-1`}
          language={language}
          {...sharedProps}
        >
          {children}
        </Link>
      ) : (
        <Anchor
          className={`hover:text-color-text-dark flex items-center no-underline ${busyClass} gap-3 px-2 py-1`}
          {...sharedProps}
        >
          {children}
        </Anchor>
      )}
    </li>
  );
};
